import { ReactNode, JSX, Fragment } from "react";
import Overline from "~/componentsDS/Typography/Overline";
import Heading from "~/componentsDS/Typography/Heading";
import VideoPlayer from "~/componentsDS/VideoPlayer";

export type StepItem = {
    imageUrl: string ;
    mobImageUrl?: string;
    videoUrl: string;
    icon?: JSX.Element;
    title: string[];
    description?: ReactNode;
}

export type PropsConsItem = {
    iconUrl: string,
    text?: string,
}

type PcosBubbleSlideProps = StepItem & {
    stepNumber: number;
};

const PcosBubbleCard = ({
    imageUrl,
    title,
    stepNumber,
    mobImageUrl,
    videoUrl,
}: PcosBubbleSlideProps) => {
    return (
        <div className="relative flex aspect-[338/338] w-full flex-col overflow-hidden rounded-2xl bg-cover bg-center bg-no-repeat md:aspect-[420/420]">
            <picture>
                <source media="(min-width: 768px)" srcSet={imageUrl} />
                <img
                    src={mobImageUrl || imageUrl}
                    alt=""
                    className="absolute inset-0 size-full object-cover"
                    aria-hidden="true"
                />
            </picture>

            <VideoPlayer
                className="absolute inset-0 size-full object-cover"
                mp4={videoUrl}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                poster={mobImageUrl || imageUrl}
            />

            <div className="pointer-events-none absolute inset-0 z-[1] rounded-2xl bg-[linear-gradient(180deg,rgba(0,0,0,0)_46.94%,rgba(0,0,0,0.53)_100%)]" />

            <div className="relative z-10 flex flex-1 gap-[13px] p-4 md:p-6">
                <div className="flex flex-1 flex-col justify-end gap-3 md:gap-4 align-middle">
                    <Overline weight="500" className="mx-auto w-[25px] h-[25px] px-[9px] md:px-3 md:py-[4px] md:w-[35px] md:h-[35px] flex items-center justify-center rounded-full bg-oestra400 font-featureDisplay text-center text-[28px] font-normal leading-[1.2] tracking-[0.36px] text-white [text-shadow:0_2px_4px_rgba(0,0,0,0.05),0_4px_6px_rgba(0,0,0,0.05)]">
                        <span className="font-suisseBP text-center text-[18px] font-normal leading-[24px] text-white [text-shadow:0_2px_4px_rgba(0,0,0,0.05),0_4px_6px_rgba(0,0,0,0.05)] md:text-[20px]">{stepNumber}</span>
                    </Overline>

                    <Heading
                        as="h3"
                        className="font-featureDisplay text-featureDisplay text-center text-[20px] font-normal leading-[1.2] tracking-[0.2px] text-white md:text-[28px] md:tracking-[0.28px] md:[text-shadow:0_2px_4px_rgba(0,0,0,0.05),0_4px_6px_rgba(0,0,0,0.05)]"
                    >
                        {title.map((line, index) => (
                            <Fragment key={`${line}-${index}`}>
                                {index > 0 && <br />}
                                {line}
                            </Fragment>
                        ))}
                    </Heading>
                </div>
            </div>
        </div>
    );
};

export default PcosBubbleCard;
